import { Dialog, FormSectionHeader, Loader, Slider } from "@/components";
import {
  MailOpen,
  Megaphone,
} from "lucide-react";
import PDFIcon from "@/assets/pdfIcon.svg";
import moment from "moment";
import useNewsLetterCard from "./useNewsLetterCard";
import noFlashNews from "@/assets/noFlashNews.png";
import { images } from "@/assets";
import { useState } from "react";
import { Button } from "@/components/ui";

const NewsLetterCard = () => {
  const [selectedFlashNews, setSelectedFlashNews] = useState<any>(null);
  const {
    files,
    flashNews,
    onNewsletterClick,
    isLoadingNewsLoading,
  } = useNewsLetterCard();

  return (
    <div className="flex flex-col gap-[20px]">
      {isLoadingNewsLoading ? (
        <Loader />
      ) : (
        <>
          <div className="bg-red-50 rounded-lg p-[20px] text-[12px]">
            <FormSectionHeader>
              <div className="flex flex-row items-center">
                <Megaphone className="mr-2" /> Flash News
              </div>
            </FormSectionHeader>
            {flashNews?.length ? (
              <Slider
                hideNextPrevButton
                autoSlide
                slides={flashNews?.map((data: any) => (
                  <div className="w-full min-w-0 flex-shrink-0 min-h-[150px]">
                    <div className="whitespace-pre-wrap break-words line-clamp-3">{data?.text}</div>
                    {data?.text?.length > 180 && (
                      <Button
                        type="button"
                        variant="link"
                        className="h-auto p-0"
                        onClick={() => setSelectedFlashNews(data)}
                      >
                        Read more
                      </Button>
                    )}
                    <br />
                    <span className="text-g-300">
                      Expires On:{" "}
                      {data?.expiry
                        ? moment(data?.expiry).format("MM/DD/YYYY")
                        : ""}{" "}
                    </span>
                  </div>
                ))}
              />
            ) : (
              <div className="flex items-center justify-center">
                <img src={noFlashNews} />
              </div>
            )}
          </div>
          <div className="bg-white rounded-lg p-[20px] h-full">
            <FormSectionHeader>
              <div className="flex flex-row items-center">
                <MailOpen className="mr-2" /> Newsletter
              </div>
            </FormSectionHeader>

            {files?.length ? (
              <div className="grid grid-cols-1 gap-[10px]">
                {files?.map((file, index: number) => (
                  <>
                    <span className="text-gray-500 text-[12px]">
                      Newsletter {index + 1}
                    </span>
                    <div className="flex flex-row gap-2 items-center">
                      {file?.name ? (
                        <img src={PDFIcon} className="h-8 w-7" />
                      ) : (
                        ""
                      )}
                      <div
                        className="flex flex-col cursor-pointer"
                        onClick={() => onNewsletterClick(file.id)}
                      >
                        <span
                          className={`text-gray-400 text-[14px] font-[500] text-sm break-all line-clamp-1 ${
                            file?.name ? "text-primary" : ""
                          }`}
                        >
                          {file?.name || ""}
                        </span>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            ) : (
              <div className="flex item-center justify-center text-[12px] h-[130px]">
                <img src={images.no_newsletter} />
              </div>
            )}
          </div>
          <Dialog
            open={!!selectedFlashNews}
            setOpen={(open: boolean) => !open && setSelectedFlashNews(null)}
            title="Flash News"
            hideFooter
            contentClassName="sm:max-w-[600px]"
          >
            <div className="whitespace-pre-wrap break-words text-sm text-gray-700">
              {selectedFlashNews?.text}
            </div>
            {selectedFlashNews?.expiry && (
              <div className="mt-4 text-xs text-g-300">
                Expires On: {moment(selectedFlashNews.expiry).format("MM/DD/YYYY")}
              </div>
            )}
          </Dialog>
        </>
      )}
    </div>
  );
};

export default NewsLetterCard;
